import {
    HeartRoundSolidIcon as HeartFilledIcon,
    HeartIcon,
} from "@wags/ui/product-icons.tsx";

import { cn } from "@wags/ui/ui-utils";

type HeartIconSwapProps = {
    isFavorited: boolean;
    className?: string;
    filledClassName: string;
    outlineClassName: string;
    haloKey?: number;
};

export function HeartIconSwap({
    isFavorited,
    className,
    filledClassName,
    outlineClassName,
    haloKey = 0,
}: HeartIconSwapProps) {
    return (
        <span className={cn("dog-save-heart-shell size-5", className)}>
            <span className="dog-save-heart-icon">
                {isFavorited ? (
                    <HeartFilledIcon className={filledClassName} />
                ) : (
                    <HeartIcon className={outlineClassName} />
                )}
            </span>
            {haloKey > 0 && isFavorited && (
                <span
                    key={haloKey}
                    className="dog-save-halo"
                    aria-hidden="true"
                >
                    <span className="dog-save-halo-ring" />
                </span>
            )}
        </span>
    );
}
